import { render, staticRenderFns } from "./health-check.vue?vue&type=template&id=38361c81&scoped=true&"
import script from "./health-check.vue?vue&type=script&lang=ts&"
export * from "./health-check.vue?vue&type=script&lang=ts&"
import style0 from "./health-check.vue?vue&type=style&index=0&id=38361c81&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38361c81",
  null
  
)

export default component.exports